import { AssessmentInfo } from "../assessment";
import { AssessmentScoring } from "../scoring/scoring";

export const bbtInfo: AssessmentInfo = {
    shortName: "BBT",
    fullName: "Box and Block Test",
    reportDescription: `\
<p>Der Box and Block Test (BBT) beurteilt die grobmotorische Handgeschicklichkeit. Er misst, wie viele Blöcke eine Person innerhalb von 60 Sekunden von einer Box in eine andere Box bewegen kann, indem sie die Blöcke mit einer Hand aufnimmt, transportiert und loslässt. Die Gesamtzahl der transferierten Blöcke zeigt das Geschicklichkeitsniveau und die Schnelligkeit der Handbewegungen an.</p>`
}

export const bbtScoring: AssessmentScoring = {
    sided: true,
    icfCategories: ["d440", "d445"],
}